import $ from 'jquery';

$('.faq__item').each(function () {
    $(this).on('click', function(){

        $(this).toggleClass('active');
        
    });
});

if ($(window).width() < 600) {
    $('.footermain .footermain__title').on('click tap', function(){
        $(this).toggleClass('clicked');
        $(this).parent().find('.menuf').slideToggle();
    });
}
$('.zol').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.ask').on('click', function(e){
    // e.preventDefault();
    $('html, body').animate({
        scrollTop: $('#formdom').offset().top - 100
    }, 500, 'linear');
});
$('.pos__top').on('click', function() {
	var parent = $(this).closest('.pos__item');
	parent.toggleClass('actives');
	parent.find('.pos__gal').toggleClass('active');
});